import { create } from 'zustand';

/** 'partner' — внешний человек со своей страницей подключения аккаунтов (23.10.2026). */
type Role = 'admin' | 'employee' | 'partner';

interface AuthState {
  userId: string | null;
  role: Role | null;
  assignedAccountIds: string[];
  accessToken: string | null;
  isLoading: boolean;
  setUser: (payload: { userId: string; role: Role; assignedAccountIds: string[]; accessToken: string }) => void;
  clearUser: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  userId: null,
  role: null,
  assignedAccountIds: [],
  accessToken: null,
  isLoading: true,
  setUser: ({ userId, role, assignedAccountIds, accessToken }) =>
    set({ userId, role, assignedAccountIds, accessToken, isLoading: false }),
  clearUser: () =>
    set({ userId: null, role: null, assignedAccountIds: [], accessToken: null, isLoading: false }),
}));
